import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

const SELECTORS = {
  container: '.js-minecraft-header',
  video: '.js-xray__video-video'
}

class MinecraftHeader {
  constructor(element) {
    this.element = element
    this.video = this.element.querySelector(SELECTORS.video)

    this.init()
  }

  init() {
    gsap.timeline({
      scrollTrigger: {
        trigger: this.element,
        start: 'top center',
        once: true,
        onEnter: () => {
          if (this.video.readyState >= 2) {
            this.video.play()
            this.element.classList.remove('-preload')
          } else {
            this.video.addEventListener('canplay', () => {
              this.video.play()
              this.element.classList.remove('-preload')
            })
          }
        }
      }
    })

    ScrollTrigger.refresh()
  }
}

export default {
  selector: SELECTORS.container,
  Source: MinecraftHeader
}
